import React, { useState } from "react";
import I18nWrapper from "components/I18nWrapper";
import ReactModal from "react-modal";
import modalPatterImage from "images/patterns/modal-pattern.svg";
import Button from "components/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { ServiceModalsContext } from "./context";
import { SERVICES_MODALS } from "./modals";
import ServiceModalContent from "./ServiceModalContent";

const ServicesModalsProvider = ({ children }) => {
  const [state, setState] = useState({
    visible: false,
    modalKey: null,
    props: null,
  });

  const openModal = (key, props = null) => {
    setState(prev => ({ ...prev, visible: true, modalKey: key, props }));
  };

  const closeModal = () => {
    setState(prev => ({
      ...prev,
      visible: false,
      modalKey: null,
      props: null,
    }));
  };

  const contextValue = { openModal, closeModal, ...state };

  const activeService = SERVICES_MODALS[state.modalKey];

  return (
    <ServiceModalsContext.Provider value={contextValue}>
      {children}
      <ReactModal
        style={{
          content: {
            width: 700,
            backgroundImage: `url(${modalPatterImage})`,
          },
          overlay: {
            background: "rgba(0, 0, 0, 0.45)",
          },
        }}
        className="react-modal"
        onRequestClose={closeModal}
        isOpen={state.visible}
      >
        <I18nWrapper>
          <div className="flex">
            <Button
              onClick={closeModal}
              className="text-md p-2 ml-auto outline-none"
            >
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          </div>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          {activeService && <ServiceModalContent {...activeService} />}
        </I18nWrapper>
      </ReactModal>
    </ServiceModalsContext.Provider>
  );
};

export default ServicesModalsProvider;
